import clsx from "clsx";
import { StackIcon } from "shared/ui";

const SortIconCampaigns = (props) => {
  const {
    flexEnd,
    idx,
    isSortedAsc,
    orderby = "",
    scrollBarWidth,
    setIsSortedAsc,
    setOrderby,
    sort,
    text,
  } = props;
  const isActive = orderby.includes(sort);
  const getSortType = (idx, type) => {
    switch (idx) {
      case "acceptance_rate":
        return `statistics/acceptance_rate ${type}`;
      case "created":
        return `created ${type}`;
      case "invitation_sent":
        return `statistics/invitation_sent ${type}`;
      case "messages_sent":
        return `statistics/messages_sent ${type}`;
      case "name":
        return `name ${type} `;
      case "persona_id":
        return `persona_id ${type}`;
      case "reply_rate":
        return `statistics/reply_rate ${type}`;
      case "started_count":
        return `statistics/started_count ${type}`;
      default:
        return `created ${type}`;
    }
  };

  const isAscend = isSortedAsc[idx];
  const willBeAsc = !isAscend || !isActive;

  return (
    <div
      className={clsx(
        isActive && "active",
        flexEnd && scrollBarWidth
          ? "container-icon-sort-end-scroll"
          : flexEnd && !scrollBarWidth
            ? "container-icon-sort-end"
            : "container-icon-sort"
      )}
      onClick={() => {
        setIsSortedAsc(idx, willBeAsc);
        setOrderby(`${getSortType(idx, willBeAsc ? "asc" : "desc")}`);
      }}
    >
      {text}

      <StackIcon
        className={clsx("title-images", {
          "title-images--active": isActive,
          "title-images--desc": !isAscend,
        })}
        icon="ascend"
        width={18}
      />
    </div>
  );
};

export default SortIconCampaigns;
